import { render, staticRenderFns } from "./AddressDetailsTable.vue?vue&type=template&id=41cf84e6&scoped=true&"
import script from "./AddressDetailsTable.vue?vue&type=script&lang=js&"
export * from "./AddressDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./AddressDetailsTable.vue?vue&type=style&index=0&id=41cf84e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cf84e6",
  null
  
)

export default component.exports